"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetSiteAssociationDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const asset_site_json_1 = require("./asset-site-json");
exports.AssetSiteAssociationDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('AssetSiteAssociation', asset_site_json_1.AssetSiteAssociationJsonMapper);
